var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "coolicon",
    filter: "url(#filter0_d_586_1386)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00023 21.9987H17.9991C18.5349 22.0192 19.0545 21.794 19.4336 21.377C19.8128 20.9599 20.0175 20.3884 19.9988 19.799V8.80026C20.0175 8.21081 19.8128 7.63931 19.4336 7.22226C19.0545 6.8052 18.5349 6.58003 17.9991 6.60051H13.9995V2.20103C14.0182 1.61158 13.8135 1.04009 13.4343 0.62303C13.0552 0.205975 12.5356 -0.0191987 11.9998 0.00128491H2.00094C1.46507 -0.0191987 0.945534 0.205975 0.566391 0.62303C0.18725 1.04009 -0.0174522 1.61158 0.0011692 2.20103V13.1997C-0.0171528 13.7891 0.187649 14.3604 0.566721 14.7774C0.945795 15.1944 1.46516 15.4196 2.00094 15.3995H6.00047V19.799C5.98215 20.3883 6.18694 20.9596 6.56602 21.3766C6.94509 21.7936 7.46446 22.0189 8.00023 21.9987ZM17.9991 8.80026V19.799H8.00023V15.3995H11.9998C12.5355 15.4196 13.0549 15.1944 13.434 14.7774C13.8131 14.3604 14.0179 13.7891 13.9995 13.1997V8.80026H17.9991ZM11.9998 2.20103V13.1997H2.00094V2.20103H11.9998Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_586_1386",
    x: 0,
    y: 0,
    width: 24,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_586_1386"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_586_1386",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copyIcon.da80e7d6.svg";
export { ForwardRef as ReactComponent };